import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bannerActions, bannerSelectors } from "../ducks/banner";

type Props = {
  campaignId?: number;
};

export const useBanner = ({ campaignId }: Props) => {
  const dispatch = useDispatch();

  const banners = useSelector(bannerSelectors.banners);

  useEffect(() => {
    dispatch(bannerActions.getBanners.started({ campaign_id: campaignId }));
  }, [campaignId]);

  return { banners };
};
